import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Tailwind-friendly className merger. Combines clsx (conditional classes) with
 * tailwind-merge (collapses conflicting Tailwind classes — last one wins).
 *
 * Usage:
 *   <div className={cn('text-ink p-4', condition && 'bg-sage', className)} />
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
